import React from 'react';

import PortfolioContainer from '@totem/components/services/optimize/v2/dashboard/PortfolioContainer';
import PortfolioPanel from '@totem/components/services/optimize/v2/dashboard/PortfolioPanel';

// Read-only embed of the separate Programs (utility-savings) feature —
// same composition optimizeLayout2.tsx already uses. Not modified.
const OptimizeProgramsTab = () => (
  <PortfolioContainer>
    <PortfolioPanel />
  </PortfolioContainer>
);

export default OptimizeProgramsTab;
